module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignature.0c92a79.jpg";